import * as React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { desktopMinWidth } from '../../tokens/mediaquery'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  publishedAt: string
}

export const NoticePublishedTime: React.FC<Props> = (props) => {
  return (
    <>
      <div
        css={css`
          color: ${colors.textLight};
          font-size: 14px;
          letter-spacing: 0.02em;
          line-height: 1.5;
          @media (min-width: ${desktopMinWidth}) {
            font-size: 16px;
          }
        `}
      >
        <FormattedDate>{props.publishedAt}</FormattedDate>
      </div>
    </>
  )
}
